import React from 'react';
import SMAppHelper from 'components/helpers/SMAppHelper';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';

class SMAboutHeaderView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      display: false,
    };
  }

  componentWillMount() {
    if (SMAppHelper.isTablet() || SMAppHelper.isTablet() == null) {
      this.setState({display: false});
    } else {
      this.setState({display: true});
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  componentDidClick(e) {
    if (SMAppHelper.isTablet() && !e.target.href) {
      this.setState({display: !this.state.display});
    }
  }

  handleResize() {
    if (!SMAppHelper.isTablet()) {
      this.setState({display: true});
    }
  }

  naviList() {
    if (this.props.isOwner) {
      return(
        <ul className="static-guide-nav__link">
          <li className="static-guide-nav__link-list"><a href={Routes.listing_about_index_path()} className={`${(this.props.selectedIndex == 1) ? ' is-current' : ''}`}>掲載するには</a></li>
          <li className="static-guide-nav__link-list"><a href={Routes.how_it_works_host_about_index_path()} className={`${(this.props.selectedIndex == 3) ? ' is-current' : ''}`}>ご利用の流れ</a></li>
          <li className="static-guide-nav__link-list"><a href={Routes.payment_flow_owner_about_index_path()} className={`${(this.props.selectedIndex == 4) ? ' is-current' : ''}`}>決済の流れ</a></li>
          <li className="static-guide-nav__link-list"><a href={Routes.how_to_host_about_index_path()} className={`${(this.props.selectedIndex == 5) ? ' is-current' : ''}`}>当日の対応</a></li>
          <li className="static-guide-nav__link-list"><a href={Routes.hospitality_about_index_path()} className={`${(this.props.selectedIndex == 6) ? ' is-current' : ''}`}>人気スペースにするには</a></li>
          <li className="static-guide-nav__link-list"><a href={Routes.host_trust_about_index_path()} className={`${(this.props.selectedIndex == 7) ? ' is-current' : ''}`}>信頼への取り組み</a></li>
          <li className="static-guide-nav__link-list"><a href={Routes.page_path('host_entry')} className={`${(this.props.selectedIndex == 2) ? ' is-current' : ''}`}>{I18n.t("service.label_000620")}</a></li>
        </ul>
      );
    } else {
      return(
        <ul className="static-guide-nav__link">
          <li className="static-guide-nav__link-list"><a href={Routes.how_it_works_about_index_path()} className={`${(this.props.selectedIndex == 1) ? ' is-current' : ''}`}>ご利用の流れ</a></li>
          <li className="static-guide-nav__link-list"><a href={Routes.payment_flow_about_index_path()} className={`${(this.props.selectedIndex == 2) ? ' is-current' : ''}`}>決済の流れ</a></li>
          <li className="static-guide-nav__link-list"><a href={Routes.how_to_stay_about_index_path()} className={`${(this.props.selectedIndex == 3) ? ' is-current' : ''}`}>当日の流れ</a></li>
          <li className="static-guide-nav__link-list"><a href={Routes.trust_about_index_path()} className={`${(this.props.selectedIndex == 4) ? ' is-current' : ''}`}>安心への取り組み</a></li>
        </ul>
      );
    }
  }

  render() {
    let title;
    if (this.props.isOwner) {
      title = "ホスト用ガイド";
    } else {
      title = "ゲスト用ガイド";
    }

    const naviList = this.state.display ? this.naviList() : "";
    return (
        <div className="clearfix static-guide-nav" onClick={this.componentDidClick.bind(this)}>
          <p className="static-guide-nav__title">{title}<i className="fa fa-angle-down ml5"></i></p>
          <CSSTransitionGroup
            transitionName="js-blind-animation"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={300} >
            {naviList}
          </CSSTransitionGroup>
        </div>
    );
  }
}
export default SMAboutHeaderView;



// WEBPACK FOOTER //
// ./app/javascript/components/about/SMAboutHeaderView.jsx